import { action, makeObservable } from 'mobx';
import { notificationError } from 'core/utils';
import { BaseViewStore } from 'core/stores';
import { sourceOfChange } from 'common/constants';
import { DuplicateReportForm } from 'modules/order/forms';
import ReportStore from 'modules/report/stores/ReportStore';
import _ from 'lodash';

class DuplicateReportViewStore extends BaseViewStore {
	report = null;
	form = new DuplicateReportForm({
		onSuccess: async () => {
			await this.editReport();
		},
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.reportStore = new ReportStore(rootStore);
		this.initialize(this.modalParams.data);
	}

	@action.bound
	initialize = async selectedReportId => {
		this.suspend();
		await this.getReport(selectedReportId);
		this.form.$('name').value = this.report.name + ' (copy)';
		this.resume();
	};

	@action.bound
	getReport = async selectedReportId => {
		this.report = await this.reportStore.getReport(selectedReportId, {
			embed: ['template', 'reportFrequency', 'users'],
		});
		this.report.id = undefined; // Removes original report id so new id will be generated on the backend
	};

	@action.bound
	editReport = async () => {
		this.suspend();
		try {
			const { name } = this.form.values();
			this.report.name = name;

			await this.reportStore.createReport(this.report, sourceOfChange.duplicateReport);

			this.rootStore.notificationStore.success(['REPORTS.MODAL.SUCCESS']);
			this.modalParams.success();
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
		this.resume();
	};
}

export default DuplicateReportViewStore;
